import styled from 'styled-components';

export const CategoryPageContainer = styled.div`
	width: 100%;
	padding: 2.5rem 1rem;

	.breadcrumbs {
		margin-bottom: 2rem;
	}

	.container {
		max-width: 1084px;
		width: 100%;
		margin: 0 auto;
	}

	.header {
		margin-bottom: 2rem;

		.title {
			margin-bottom: 0.25rem;
		}

		.meta-text {
			color: ${({ theme }) => theme.v3.colors.dark[0]};
		}
	}

	.card {
		flex: 0 1 calc(33.33% - 2rem);
	}
`;
